import { styled } from "styled-components";
import { grid } from "../../mixins";

export const Wrapper = styled.section`
  ${grid()}
  grid-template-columns: 1fr;
  grid-template-rows: 30px;

  h1 {
    margin: 0;
    padding: 0;
    font-family: var(--landrina-font);
    text-align: center;
    font-size: 4.052rem;

    color: transparent;
    background-image: linear-gradient(to right, #f00, #ff0, #0ff, #0f0, #00f);
    background-clip: text;
    -webkit-background-clip: text;
    animation: animate 20s linear infinite;
    background-size: 1000%;
    @keyframes animate {
      0% {
        background-position: 0% 100%;
      }
      5% {
        background-position: 100% 0%;
      }
      100% {
        background-position: 0% 100%;
      }
    }
  }
`;
